<script lang="ts">
    import { captureMessage } from '../../utilities/Sentry';
    import { openModal } from 'svelte-modals';
    import { get } from 'svelte/store';
    import { _ } from 'svelte-i18n';

    import ButtonSmallBlueRounded from '../../shared/ButtonSmallBlueRounded.svelte';
    import lockSvg from '../../shared/Icons/svg/lock_FILL0_wght400_GRAD0_opsz24.svg';
    import { debug, jobs, planning, scenarioManager } from '../../../stores/store';
    import ButtonRoundReload from '../../shared/ButtonRoundReload.svelte';
    import { AssignmentBulkActions } from './AssignmentBulkActions';
    import IconUnlockRoute from '../../shared/Icons/IconUnlockRoute.svelte';
    import IconLockRoute from '../../shared/Icons/IconLockRoute.svelte';
    import ModalInfo from '../../shared/Modals/ModalInfo.svelte';
    import { AssignmentApi } from './AssignmentApi';
    import { Assignment } from './Assignment';
    import { api } from '../../../stores/api';
    import WarningColor from '../../shared/WarningColor.svelte';
    import { features } from '../../shared/Features/features';
    import { Umami } from '../../utilities/Umami';

    export let assignment: Assignment;
    export let showButtons: boolean = false;
    export let showUnlockButtons: boolean = false;
    export let showSendButtons: boolean = false;
    export let disabled: boolean = false;

    let loading: boolean = false;

    export function isLoading(): boolean {
        return loading;
    }

    export function toggleLocked() {
        console.log('toggleLocked');
        assignment = assignment;
        if (assignment.isLocked()) {
            loading = true;
            // unlock but only if not downloaded (check if downloaded)
            AssignmentApi.getOne(get(api), assignment.getId()).then(ass => {
                if (new Assignment(ass).isDownloaded()) {
                    openModal(ModalInfo, {
                        text: $_(
                            'The route was just downloaded by the courier - It cannot be unlocked'
                        ),
                    });
                    loading = false;
                } else {
                    AssignmentApi.setLocked(get(api), assignment.getId(), false)
                        .then(_ => {
                            assignment = assignment.setLocked(false);
                            console.log('toggleLocked, planning page');
                            AssignmentApi.getOneWithCountersByAssignmentId(
                                get(api),
                                assignment.getId()
                            )
                                .then(res => {
                                    console.log('toggleLocked, set committed', res);
                                    if (res) {
                                        $scenarioManager.updateAssignment(res);
                                        $scenarioManager = $scenarioManager;
                                        // assignment.setLocked(!assignment.isLocked());
                                        assignment.updateQuickCategories();
                                        assignment = assignment.set(res);
                                        $jobs.forceRecount = true;
                                        loading = false;
                                    }
                                })
                                .catch(err => {
                                    alert('getOne: ' + err);
                                    captureMessage(err);
                                    loading = false;
                                });
                        })
                        .catch(err => {
                            alert(err);
                            captureMessage(err);
                            loading = false;
                        });
                }
            });
        } else {
            if (!assignment.isRouteOrderModified()) {
                // let datetime = `${$planning.selectedDay} ${$planning.selectedRouteEnableTime}:00`;
                loading = true;
                assignment = assignment.setLocked(true);
                Umami.event('route_send_to_driver', { assignment_id: assignment.getId() });
                AssignmentBulkActions.lockAssignment2(
                    get(api),
                    assignment.getId(),
                    $scenarioManager
                )
                    .then(errors => {
                        $jobs.forceRecount = true;
                    })
                    .catch(err => {
                        console.error('lockAssignments error', err);
                        captureMessage(err);
                    })
                    .finally(() => {
                        loading = false;
                    });
            } else {
                openModal(ModalInfo, {
                    text: $_('The route was modified after download - It cannot be locked'),
                });
            }
        }
    }
</script>

{#if assignment.isDefault() && assignment.hasVehicleAssigned()}
    {#if showSendButtons && !assignment.isLocked()}
        <ButtonSmallBlueRounded
            disabled={loading || disabled}
            text={$_('Send')}
            on:click={toggleLocked}
            displayMode="small"
        />
    {/if}
    {#if showUnlockButtons && assignment.isLocked()}
        <IconUnlockRoute scale={0.7} on:click={toggleLocked} disabled={loading || disabled} />
    {/if}

    {#if showButtons}
        {#if assignment.hasRouteBeenEverDownloaded()}
            <!-- https://er.automapa.pl/documents/23 -->
            <!-- 5. widzimy na liście, który kierowca pobrał trase = rozpoczął realizacje. Takiej trasy nie mozemy już “odkłódkować” i zmienić w trybie normalnym, a jedynie w trybie adhoc (#D1A)-->
            {#if assignment.getRsa().isBaseRouteComparable()}
                {#if assignment.isRouteInvalid()}
                    <ButtonRoundReload
                        {disabled}
                        title={$_('recalculate_route')}
                        on:click={async () => {
                            assignment = assignment.setBusy(true);
                            await assignment.prepareRouteForRecalculation();
                            AssignmentBulkActions.calculateRoute2(
                                get(api),
                                assignment.getId(),
                                assignment.getScenarioId(),
                                data => {
                                    assignment = assignment.set(data);
                                    $scenarioManager.updateAssignment(data);
                                }
                            )
                                .then(errors => {
                                    if (errors.length) console.error(errors);
                                })
                                .finally(() => {
                                    assignment = assignment.setBusy(false);
                                });
                        }}
                    />
                {/if}
                <ButtonSmallBlueRounded
                    disabled={assignment.isRouteInvalid() || disabled}
                    text={$_('Send')}
                    on:click={toggleLocked}
                />
            {/if}
        {:else if assignment.isLocked()}
            <ButtonSmallBlueRounded
                disabled={loading || disabled}
                text={$_('Change')}
                colorMode="black"
                showIcon={lockSvg}
                on:click={toggleLocked}
            />
        {:else if assignment.isRouteCalculated() && assignment.hasVehicleAssigned()}
            <ButtonSmallBlueRounded
                disabled={loading || disabled}
                text={$_('Send')}
                on:click={toggleLocked}
            />
        {:else}
            <div style="opacity: 0.2;">
                <IconLockRoute
                    {disabled}
                    scale={0.7}
                    on:click={() => {
                        console.warn('TODO: Not implemented');
                    }}
                />
            </div>
        {/if}
    {/if}
    <!--{#if showUnlockButtons}-->
    <!--    {#if showUnlockButtons}-->
    <!--        <IconUnlockRoute scale={0.7} on:click={toggleLocked} disabled={loading} />-->
    <!--    {/if}-->
    <!--{/if}-->
    <!--{#if assignment.isRouteCalculated() && assignment.hasVehicleAssigned()}-->
    <!--    {#if showSendButtons}-->
    <!--        <ButtonSmallBlueRounded-->
    <!--            disabled={loading}-->
    <!--            text={$_('Send')}-->
    <!--            on:click={toggleLocked}-->
    <!--            displayMode="small"-->
    <!--        />-->
    <!--    {/if}-->
    <!--    &lt;!&ndash;{:else}&ndash;&gt;-->
    <!--    &lt;!&ndash;    <div style="opacity: 0.2;">&ndash;&gt;-->
    <!--    &lt;!&ndash;        <IconLockRoute scale={0.7} on:click={() => {}} />&ndash;&gt;-->
    <!--    &lt;!&ndash;    </div>&ndash;&gt;-->
    <!--{/if}-->
{/if}
